<!-- HomePage.vue -->
<script setup>
import { onMounted, ref } from 'vue'
import { useMeetingStore } from '@/store/meetingStore'

import trpc from '@/trpc'

import { formatDate } from '@/lib/utils/dateUtils'

const props = defineProps(['session'])
const { session } = toRefs(props)

function hello() {
  /*
  trpc.hello.query("helllloooo999").then((res) => {
    console.log(res);
  });
  return "Hello World";
  */
}

function initializeMentor() {
  /// TBD: This is just a placeholder for now
  trpc.initializeMentor.query('helllloooo999').then((res) => {
    console.log(res)
  })
  return 'Hello World'
}

const clients = ref([])

function fetchClients() {
  try {
    const meetingStore = useMeetingStore()
    // Keeping original property names from API response
    clients.value = meetingStore.patients.map(patient => ({
      ...patient,
      activities: patient.activities?.filter(a => a.completed).length || 0,
      lastUpdate: patient.lastUpdate || new Date(),
      status: patient.status || 'active',
      program: patient.program || 'General Program',
    }))
  }
  catch (err) {
    console.error('Error loading patients:', err)
  }
}

function handleNewActivity() {
  console.log('New activity action triggered')
  // Implementation for new activity
}

function handlePlanMeeting() {
  console.log('Plan meeting action triggered')
  // Implementation for planning a meeting
}

function handleAddClient() {
  console.log('Add client action triggered')
  // Implementation for adding a client
}

onMounted(() => {
  initializeMentor()
  // Data is already loaded in App.vue, just populate clients from store
  fetchClients()
})

// Données des concepts principaux

// TODO: Load from Blog route
const concepts = ref([
  {
    id: 1,
    title: 'Débuter avec Selfwise',
    description:
      'Découvrez comment Selfwise transforme l\'approche du coaching professionnel. Notre plateforme combine l\'intelligence artificielle et les meilleures pratiques du coaching pour offrir un accompagnement personnalisé et innovant. Idéal pour les coachs qui souhaitent digitaliser leur pratique et maximiser l\'impact de leurs séances.',
    category: 'introduction',
    link: '/getting-started',
  },
  {
    id: 2,
    title: 'Créer des activités personnalisées',
    description:
      'Développez des exercices et des programmes sur mesure pour vos clients. Notre interface intuitive vous permet de créer des parcours de coaching adaptés aux objectifs spécifiques de chaque client, qu\'il s\'agisse de développement professionnel, de leadership ou de gestion du changement.',
    category: 'création',
    link: '/create-activity',
  },
  {
    id: 3,
    title: 'Participez au développement',
    description:
      'Votre expertise enrichit notre plateforme ! En tant que coach professionnel, vos retours sont précieux pour façonner l\'avenir du coaching digital. Partagez vos idées pour améliorer Selfwise et contribuez à créer des outils qui répondent aux besoins réels des coachs et de leurs clients.',
    category: 'communauté',
    link: '/contribute',
  },
])

// Données pour la barre latérale
const asideTab = ref('clients')

const activites = ref([
  {
    id: 1,
    titre: 'Bilan de compétences',
    type: 'Évaluation',
    statut: 'En cours',
  },
  {
    id: 2,
    titre: 'Gestion du stress',
    type: 'Atelier',
    statut: 'Planifié',
  },
  {
    id: 3,
    titre: 'Leadership situationnel',
    type: 'Formation',
    statut: 'Terminé',
  },
])

// Fonction pour formater la date
function formaterDate(date) {
  return formatDate(date)
}
</script>

<template>
  <div>
    <!-- Action Bar -->

    <HomeDash :session="session" :clients="clients" />

    <BrochureFooter class="" />
  </div>
</template>

<style scoped>
.bg-surface {
  background-color: hsl(var(--background));
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
